import getMiniDecimal from "./MiniDecimal";
export * from "./MiniDecimal";
import { trimNumber, getNumberPrecision, num2str, validateNumber } from "./numberUtil";
export { trimNumber, getNumberPrecision, num2str, validateNumber };
export default getMiniDecimal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rc-component/mini-decimal/es/index.js
// module id = 883
// module chunks = 0